import React from "react";
import { FormattedMessage } from "react-intl";

const DisponibilidadImportarReporte = ({ data = [], callbackReportClose }) => {
  return (
    <div>
      <h5 className="mb-3">
        <FormattedMessage id="disponibilidadImportar.reporte.titulo" defaultMessage="Filas que fallaron" />
      </h5>
      {Array.isArray(data) && data.length > 0 ? (
        <div style={{ maxHeight: 350, overflowY: "auto" }}>
          <table className="table table-bordered table-sm">
            <thead>
              <tr style={{ background: '#241b3e' }}>
                <th style={{ background: '#241b3e', color: '#fff' }}>
                  <FormattedMessage id="disponibilidadImportar.reporte.columna.fila" defaultMessage="Fila" />
                </th>
                <th style={{ background: '#241b3e', color: '#fff' }}>
                  <FormattedMessage id="disponibilidadImportar.reporte.columna.error" defaultMessage="Error" />
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.fila || idx + 1}</td>
                  <td>
                    {Array.isArray(item.errores)
                      ? item.errores.join(", ")
                      : item.errores || item}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="alert alert-success">
          <FormattedMessage id="disponibilidadImportar.reporte.sin_errores" defaultMessage="No hubo filas con errores." />
        </div>
      )}
    </div>
  );
};

export default DisponibilidadImportarReporte;
